export default {
  loggedIn: {
    deposit: 'Nạp tiền',
    withdraw: 'Rút tiền',
    balance: 'Tổng số dư',
    cash: 'Tiền mặt',
    bonus: 'Tiền thưởng',
    withdrawable: 'Có thể rút',
    transaction: 'Giao dịch',
    history: 'Lịch sử',
    myBet: 'My Bet',
    rollover: 'Rollover',
    vault: 'Két sắt',
    notification: 'Thông báo',
    affiliate: 'Đại lý - Kiếm $5.000 Mỗi Tháng',
    affiliateTitle: 'Đại lý',
    affiliateBadge: 'Kiếm $5.000 Mỗi Tháng',
    settings: 'Cài đặt',
    currency: 'Tiền tệ',
    language: 'Ngôn ngữ',
    liveSupport: 'Hỗ trợ trực tuyến',
    signOut: 'Đăng xuất'
  }
};
